const isTauri = !!(window as unknown as Record<string, unknown>).__TAURI_INTERNALS__;

if (isTauri) {
  import('./style.css');
  import('./app').then(({ bootstrapApp }) => {
    void bootstrapApp(document.querySelector('#app'));
  });
} else {
  import('./web/webTheme.css');
  import('./web/webLayout.css');
  const webRoot = document.querySelector('#web-root');
  if (webRoot) (webRoot as HTMLElement).style.display = '';
  const appRoot = document.querySelector('#app');
  if (appRoot) (appRoot as HTMLElement).style.display = 'none';
  import('./web/webApp').then(({ bootstrapWebApp }) => {
    void bootstrapWebApp(webRoot as HTMLElement);
  });
}
